import type {
  CustomVendor,
  CustomVendorConsentsResult,
  TcData,
  TcfApiCallback,
  UserConsent,
} from '@/types/consent'
import { isBrowser } from '@/utils/app/detect'

const TCF_VERSION = 2
const TCF_DIALOG_ID = 169018

/**
 * TCF/Sourcepoint IDs for non-IAB vendors
 *
 * @see https://analytics.sourcepoint.com/consent_v2/vendor_lists
 */
export const TCF_VENDOR_IDS: { [key: string]: string } = {}

const createUserConsent = (
  tcString: string,
  { consentedPurposes, consentedVendors, grants }: CustomVendorConsentsResult,
): UserConsent => ({
  tcString,
  consentedPurposes,
  consentedVendors,
  grants,
})

const makeConsentUpdateHandler = (callback: (consent: UserConsent) => void) => {
  const baseHandler: TcfApiCallback = (tcData: TcData, success: boolean) => {
    baseHandler.listenerId = tcData.listenerId
    if (
      success &&
      (tcData.eventStatus === 'tcloaded' ||
        tcData.eventStatus === 'useractioncomplete') &&
      window.__tcfapi
    ) {
      window.__tcfapi(
        'getCustomVendorConsents',
        TCF_VERSION,
        (
          vendorConsents: CustomVendorConsentsResult,
          getCustomVendorSuccess: boolean,
        ) => {
          if (getCustomVendorSuccess) {
            callback(createUserConsent(tcData.tcString, vendorConsents))
          }
        },
      )
    }
  }

  return baseHandler
}

export const setCustomConsentForProvider = (
  vendorId: string,
  callback: (data: Array<CustomVendor>) => void,
): void => {
  if (window.__tcfapi) {
    window.__tcfapi(
      'postCustomConsent',
      TCF_VERSION,
      (data: TcData, success: boolean) => {
        if (success) {
          callback(data.customVendorsResponse.consentedVendors)
        }
      },
      [vendorId],
      [],
      [],
    )
  }
}

export const listenForConsent = (callback: (data: UserConsent) => void) => {
  if (isBrowser()) {
    const handler = makeConsentUpdateHandler(callback)

    if (window.__tcfapi) {
      window.__tcfapi('addEventListener', TCF_VERSION, handler)
    }

    return () => {
      if (window.__tcfapi && Number.isInteger(handler.listenerId)) {
        window.__tcfapi(
          'removeEventListener',
          TCF_VERSION,
          handler,
          handler.listenerId,
        )
      }
    }
  }
}

export const openPrivacyCenter = (): void => {
  ;(window as any).__TRIGGER_RELOAD__ = true
  ;(window._sp_ as any)?.gdpr?.loadPrivacyManagerModal?.(TCF_DIALOG_ID)

  setTimeout(() => window.dispatchEvent(new Event('AC_show_pc')), 100)
}
